// ==============================|| LOADABLE - LAZY LOADING ||============================== //

// const Loadable = (Component: ElementType) => (props: any) =>
//   (
//     <Suspense fallback={<Loader />}>
//       <Component {...props} />
//     </Suspense>
//   );

// export default Loadable;

import { Suspense, ComponentType, useEffect } from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import Loader from './Loader';

const ErrorFallback = ({ error }: FallbackProps) => {
  const isChunkError =
    error?.name === 'ChunkLoadError' ||
    error?.message?.includes('Loading chunk') ||
    error?.message?.includes('Failed to fetch dynamically imported module');

  useEffect(() => {
    if (isChunkError) {
      // Automatically reload for stale chunks
      console.warn('Chunk error detected. Reloading...');
      setTimeout(() => window.location.reload(), 100);
    }
  }, [isChunkError]);

  return null;
};

const Loadable = (Component: ComponentType<any>) => (props: any) =>
  (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {}}
      onError={(error: any, info:any) => {
        console.error('Error in lazy-loaded component:', error);
        console.error('Component stack:', info);
      }}
    >
      <Suspense fallback={<Loader />}>
        <Component {...props} />
      </Suspense>
    </ErrorBoundary>
  );

export default Loadable;
